import { render, staticRenderFns } from "./AddLicenceForPatientDrawer.vue?vue&type=template&id=508c7f0e"
import script from "./AddLicenceForPatientDrawer.vue?vue&type=script&lang=js"
export * from "./AddLicenceForPatientDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports